import React, {useState, useRef, useEffect} from 'react';
import { 
  Add as AddIcon, 
  Close as CloseIcon,  
  RemoveCircleOutline as DeleteIcon,
  DragIndicator as DragIndicatorIcon
} from "@material-ui/icons";
//custom components
import AutoFieldDialog from "../../MultiStepDialog/AutoFieldDialog";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

//REDUX
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchActionFields, fetchActionMetafields, saveActionFields } from "../../../../redux/actions/connectionActions";
import { pushMessage, removeMessage } from "../../../../redux/actions/commonActions";
//MUI helpers
import { makeStyles } from '@material-ui/core/styles';
//MUI components
import { 
    Paper,
    List, 
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    IconButton,
    Box,
    Typography,
    TextField,
    Button,  
    Tooltip
} from '@material-ui/core';

//shared styles
import { Dashboard as DashboardLayout } from "layouts";
import Loader from '../../../../components/Loader';
import logo from './../../assets/responsum.png';


// Component styles
import styles from "./../ActionButtonEditor/styles.js";
const useStyles = makeStyles(styles);


const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  boxShadow: isDragging ? "0 10px 15px -10px #B7C0CD" : "none",
  borderLeft: isDragging ? "3px solid orange" : "3px solid white",
  ...draggableStyle
});


function ActionButtonCreator(props){
    const classes = useStyles();
    const[filterOpen, setFilterOpen] = useState(false);
    const[fieldDialogOpen, setFieldDialogOpen] = useState(false);
    const[autoDialogOpen, setAutoDialogOpen] = useState(false);
    const[activeValue, setActiveValue] = useState(null);
    const[activeIndex, setActiveIndex] = useState(0);
    const[actions, setActions] = useState([{
      "fields": [],
      "title": "",
      "autofields":[],
      "SK": "Salesforce#test"
    }]); 
    const[buttonDisabled, setButtonDisabled] = useState(true);
   

    useEffect(()=>{
      if(props.tenant === undefined)return;
      props.fetchActionMetafields('salesforce_iolap_metafields'); //TODO: fetch metafields by dynamic index
    }, [props.tenant]) 

    useEffect(()=>{
      if(props.saveStatus === undefined)return;
      if(props.saveStatus.status === 200) {

        props.pushMessage({
          message: "Saving completed successfully!",
          type: "success"
        });
        setTimeout(() => {
          props.history.push("/action-buttons")
        }, 1000);
      }else if(props.saveStatus.status === 500){
        props.pushMessage({ 
          message: "Error while trying to save.",
          type: "error"
        });
      }
    }, [props.saveStatus]) 

    function onDragEnd(result) {
      if (!result.destination) { return; }
      if (result.destination.index === result.source.index) { return; }
      const allActions = [...actions];
      const targetAction = {...allActions[0]};
      const fields = [...targetAction.fields];
      const reorderedFields = reorder(
        fields,
        result.source.index,
        result.destination.index
      ); 
      targetAction.fields = reorderedFields;
      allActions[0] = targetAction; 
      setActions( allActions );
    }
    
    const reorder = (list, startIndex, endIndex) => {
      const [removed] = list.splice(startIndex, 1);
      list.splice(endIndex, 0, removed);
      return list;
    };
    
    const handleSaveChanges = () => {
      props.pushMessage({
        message: "Saving data don't leave the page",
        type: "info"
      })
      let actionButtonSettings = {...actions[0]};
      actionButtonSettings.fields = [...actions[0].fields, ...actions[0].autofields];
      delete actionButtonSettings.autofields;
      props.saveActionFields(actionButtonSettings, props.tenant); 
    } 
    
    const handleActionChange = (e) => {
      const {value, name}  = e.target;
      setActions(actions.map((item, i) => i === activeIndex ? {...item, [name]: value}:item)); 
      value.length>0?setButtonDisabled(false):setButtonDisabled(true);
    }

    function getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
  }

    const setNewField = (fieldType) => {
      if(!activeValue)return;
      let fields = [...actions[activeIndex][fieldType]]??[];
      fields.push(activeValue);
      setActiveValue(null);
      const uniqueFields = getUniqueListBy(fields, "field");
      if(fields.length>uniqueFields.length){
          props.pushMessage({
            message: "Field already exists in the form.",
            type: "info"
          })
        setFieldDialogOpen(false); 
        return;
      }
      setActions(actions.map((item, i) => i === activeIndex ? {...item, [fieldType]: uniqueFields}:item)); 
      setFieldDialogOpen(false); 
    }

    const addNewField = (value) => {
      if(value){
        setActiveValue({
          field: value.name,
          label: value.label,
          table: value.id.substr(0, value.id.indexOf('.')),
          value: value.value,
          hidden: value.hidden
        });
      }
    }

    const deleteField = (index) => {
      let newFields = [...actions[activeIndex].fields];
      newFields.splice(index, 1);
      setActions(actions.map((item, i) => i === activeIndex ? {...item, fields: newFields}:item)); 
    } 

    const deleteAutoField = (index) => {
      let newFields = [...actions[activeIndex].autofields];
      newFields.splice(index, 1);
      setActions(actions.map((item, i) => i === activeIndex ? {...item, autofields: newFields}:item));
    }

    
    if(actions) {
      var fieldsCount = actions.length>0?actions[activeIndex].fields.length:0;
    }

    return  <DashboardLayout title="Response Manager">
            <Box>
                <Typography variant="h3" component="h3">Create New Button</Typography>
            </Box><br /><br /><br />
            <Paper className={classes.editorContainer}>
                <Box className={classes.responseDetails}>
                    <Box>
                       <div className={classes.detailsSectionTitle}>
                            <Typography variant="h5">Button Name</Typography>
                        </div> 
                        <TextField fullWidth={true} name="title" value={actions[activeIndex].title} onChange={(e) => handleActionChange(e)} className={classes.editorTextInput} variant="outlined" />
                        <br /><br />

                        <div className={classes.detailsSectionTitle}>
                            <Typography variant="h5">Form Fields</Typography>
                        </div> 
                        <Paper className={classes.fieldListHolder} variant="outlined">  
                          <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="list">
                              {provided => (
                              <List disablePadding ref={provided.innerRef} {...provided.droppableProps}>
                                {actions[activeIndex].fields.map((item, index) => (
                                  <Draggable key={item.field} draggableId={item.field} index={index}>
                                  {(provided, snapshot) => (
                                    <ListItem key={item.field} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)} className={classes.fieldList}>
                                      <DragIndicatorIcon className={classes.dndIcon} />
                                      <ListItemText>{item.label}<span><Typography variant="subtitle1">{item.value&&`Default value: ${item.value}`}</Typography></span>
                                        <ListItemSecondaryAction>
                                          <div style={{position:"relative"}}>
                                            <Tooltip title="Delete Field">
                                              <IconButton size="small" onClick={() => deleteField(index)} edge="end" aria-label="delete">
                                                <DeleteIcon className={classes.actionIcon} />
                                              </IconButton>
                                            </Tooltip>
                                          </div>
                                        </ListItemSecondaryAction>
                                      </ListItemText>
                                    </ListItem>
                                    )}
                                  </Draggable>
                                ))}
                                {provided.placeholder}
                              </List>
                              )}
                            </Droppable>
                          </DragDropContext>
                          
                          <Button
                            color="primary"
                            size="medium" 
                            fullWidth={true}
                            onClick={() => setFieldDialogOpen(true)}
                            aria-controls={filterOpen ? 'split-button-menu' : undefined}
                            aria-expanded={filterOpen ? 'true' : undefined}
                            aria-haspopup="menu"
                            classes={{root: classes.customAddButton}}
                            ><AddIcon /> Add Form Field</Button>
                        </Paper><br /> 
                        <div className={classes.detailsSectionTitle}>
                            <Typography variant="h5">Auto Updated Fields</Typography>
                        </div> 
                        <Paper className={classes.fieldListHolder} variant="outlined">  
                          <List disablePadding>
                            
                            {actions[activeIndex].autofields&&actions[activeIndex].autofields.map((item, index) => (
                              <React.Fragment key={item.field}>
                                <ListItem className={classes.fieldList}>
                                  <ListItemText style={{minWidth: "60%"}}>
                                  {item.label}
                                  <span><Typography variant="subtitle1">Will update to</Typography></span>
                                  </ListItemText>
                                  <ListItemText>
                                    {item.value} 
                                  </ListItemText>
                                    <ListItemSecondaryAction>
                                      <Tooltip title="Delete Field">
                                        <IconButton size="small" onClick={() => deleteAutoField(index)} edge="end" aria-label="delete">
                                          <DeleteIcon className={classes.actionIcon} />
                                        </IconButton>
                                      </Tooltip>
                                    </ListItemSecondaryAction>
                                </ListItem>
                              </React.Fragment>
                            ))}

                          </List>
                          <Button
                                color="primary"
                                size="medium" 
                                fullWidth={true}
                                onClick={() => setAutoDialogOpen(true)}
                                aria-controls={filterOpen ? 'split-button-menu' : undefined}
                                aria-expanded={filterOpen ? 'true' : undefined}
                                aria-haspopup="menu"
                                classes={{root: classes.customAddButton}}
                            ><AddIcon /> Add Auto Updated Field</Button>
                        </Paper>
                        <Button onClick={() => handleSaveChanges()} className={classes.saveButton} disabled={buttonDisabled} color="primary" variant="contained" size="large">Save</Button>
                        <Button onClick={() => (props.history.push("/action-buttons"))} className={classes.saveButton} color="primary" variant="outlined" size="large">Cancel</Button>
                    </Box>
                </Box>
                <Box className={classes.responsePreview}>
                    {fieldsCount>0?
                    <>
                    <Typography style={{opacity: .3, marginTop: 20}} variant="h5">Form Preview</Typography>
                    <Paper className={classes.previewContainer} >
                        <div className={classes.previewTitle} >
                            <img src={logo} />
                            <Typography variant="h4">{actions[activeIndex].title}</Typography><br />
                        </div>
                        {actions[activeIndex].fields.map(item => (
                            <p key={item.field} className={classes.inputPreview}>{item.label}</p>
                        ))}
                        <div className={classes.previewActions}>
                          <button>Close</button><button className={classes.previewActionButton}>Submit</button>
                        </div>
                    </Paper>
                    </>:<Typography variant="h3" className={classes.noFieldsSign}>Please add form field to preview the form.</Typography>
                    }
                </Box>
                </Paper>
                {fieldDialogOpen&&
                  <AutoFieldDialog 
                    setDialog={setFieldDialogOpen} 
                    showDialog={fieldDialogOpen} 
                    metafields={props.metafields}
                    addNewField={addNewField}
                    setNewField={setNewField}
                    activeValue={activeValue}
                    fieldType="fields"
                    dialogTitle={"New Form Field"}
                  />
                }
                {autoDialogOpen&&
                  <AutoFieldDialog 
                    setDialog={setAutoDialogOpen} 
                    showDialog={autoDialogOpen} 
                    metafields={props.metafields}
                    addNewField={addNewField}
                    setNewField={setNewField}
                    activeValue={activeValue}
                    fieldType="autofields"
                    dialogTitle={"New Auto Updated Field"}
                  />
                }
            </DashboardLayout>
}

function mapStateToProps(state) {
  return {
    metafields: state.connections.metafields,
    tenant: state.skill.tenant,
    saveStatus: state.connections.saveStatus
  }
}

function mapDispatchToProps(dispatch) {
  return{
    ...bindActionCreators({
      fetchActionMetafields,
      saveActionFields,
      pushMessage,
      removeMessage
    }, dispatch),
    dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActionButtonCreator);

